<template>
<div class="card">
  <h6 class="style-text">درجه حرارت</h6>
  <div class="card-body">
    <h3><b>دماسنج گوش</b></h3>
    <a href="#" class="btn btn-primary"><b-icon icon="cart-fill" class="cart-1"/>خرید</a>
     <span class="text-success font-weight-bold font-3 m-2">49000تومان</span>
     
  </div>
</div>
</template>

<script>
export default {
    name:"S503",

};
</script>

<style scoped>

h1 {
  color: black;
}

.menu-1 {
  margin-right: 350px;
}

.Place-Badges{
   position: absolute;
  left: 15px;
  top: 1px;
 }

 .font-1 {
   font-size: 60px;
 }

 .font-2 {
   font-size: 60px;
 }

 .font-3 {
   font-size: 25px;
 }

 .cart-1 {
   margin: 5px;
   color: rgb(234, 238, 238);
 }

.add-style-text:hover {
  background-color:rgb(221, 138, 14) !important;
  color:black;
}

.style-card {
  border: 20px;
}

.style-text {
  color:cadetblue;
  margin-top: 40px;
  margin-right: 20px;
}

.card {
  background-color: blueviolet;
}


 



</style>